var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"player",staticClass:"user"},[_c('div',{staticClass:"video"}),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.user.role)+"："+_vm._s(_vm.user.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }